import { useOutletContext } from 'react-router-dom';
import type { PortalOutletContext } from './portal-outlet-context';

export function usePortalOutlet(): PortalOutletContext {
    return useOutletContext<PortalOutletContext>();
}
